export default {
  title: 'MAXHUB Aktivieren',
  instruction: 'Bitte geben Sie die Nutzer- und Händlerinformationen ordnungsgemäß an, die in Verbindung mit dem Kundendienst stehen',
  dealername: 'Name des Händlers',
  dealerplaceholder: 'Name des Händlers',
  companyname: 'Name der Firma',
  companyplaceholder: 'Name der Firma',
  tele: 'Kontaktinformation',
  teleplaceholder: 'Mobiltelefon',
  district: 'Gebietswahl',
  distplaceholder: 'Gebietsinformation',
  address: 'Detaillierte Anschrift',
  addrplaceholder: 'Detaillierte Anschrift',
  activebtn: 'Erhalten Sie den Code',
  confirmbtn: 'Bestätigen',
  cancelbtn: 'Stornieren',
  dialogmessage: 'Das Mobiltelefon-Format ist falsch, bitte geben Sie es erneut ein',
  dialogbtn: 'Bestätigen',
  errortitle: 'Kann nicht öffnen',
  errorinfo1: 'Versuchen Sie eine Netzwerkprüfung',
  errorinfo2: 'Hotline 400-168-9545',
  nosn: 'Dieses Gerät kann nicht aktiviert werden ohne SN',
  activepagetitle: 'Aktivierungscode',
  activepagehint: 'Bitte geben Sie den Aktivierungscode ein, um das Gerät zu aktivieren',
  finish: 'vollständige',
  search: 'Suche in der nähe von'
};



// WEBPACK FOOTER //
// ./src/i18n/_de.js